export const BRAND = {
  name: "NŪRA",
  country: { fr: "Suisse", en: "Switzerland" },
  contactEmail: "contact@nura-coffee.com",
  shipping: { cost: 7, freeFrom: 50, handlingDays: { fr: "1 à 2 jours ouvrables", en: "1–2 business days" } },
  returnDays: 14,
  payment: "Stripe",
  vatRate: 2.6,
};

export const LEGAL_NOTE = {
  fr: "Denrées alimentaires formulées sans sucre ajouté. Nos descriptions portent sur la composition, le goût et le moment de dégustation — non sur des effets thérapeutiques. Elles ne remplacent pas une alimentation variée et équilibrée. Femmes enceintes ou allaitantes, personnes sous traitement : demandez conseil à un professionnel de santé. La liste complète des ingrédients, les allergènes et les valeurs nutritionnelles figurent sur l'emballage.",
  en: "Foods formulated with no added sugar. Our descriptions cover composition, taste and the moment of enjoyment — not therapeutic effects. They are not a substitute for a varied, balanced diet. Pregnant or breastfeeding women and people under treatment: seek advice from a healthcare professional. The full ingredient list, allergens and nutrition facts are printed on the packaging.",
};
